// Employee codes are issued as IN-1234 / MB-1234 — two letters, a dash and four digits.
export const EMPLOYEE_CODE_PATTERN = '(IN|MB)-[0-9]{4}'
export const EMPLOYEE_CODE_PLACEHOLDER = 'IN-1234 / MB-1234'
export const EMPLOYEE_CODE_REGEX = /^(IN|MB)-\d{4}$/
